<template>
    <div class="select-product">
        <el-dialog title="添加" :visible.sync="dialogVisible" width="768px" :before-close="close">
            <div class="form">
                <el-form :model="formInline" ref="formInline" class="demo-form-inline" label-position="left" label-width="120px">
                    <el-form-item label="平台名称：" prop="platform_id">
                        <el-select v-model="formInline.platform_id" placeholder="请选择平台名称" style="width: 400px">
                            <el-option v-for="item in platformList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="商品URL地址：" prop="url">
                        <el-input v-model="formInline.url" placeholder="请输入商品URL地址" clearable style="width: 400px; margin-right: 20px"></el-input>
                        <el-button @click="createProduct" size="medium" type="primary" :loading="addLoad">添加</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="table">
                <el-table v-loading="tabload" ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" stripe>
                    <el-table-column label="编号" align="center" prop="id" width="100px"> </el-table-column>
                    <el-table-column prop="plateform_name" label="平台名称" align="center"> </el-table-column>
                    <el-table-column prop="url" label="商品URL地址" align="center">
                        <template slot-scope="scope">
                            <el-tooltip v-if="scope.row.url && scope.row.url.length > 24" :content="scope.row.url" placement="top" effect="light">
                                <span>{{ scope.row.url | strFmt }}</span>
                            </el-tooltip>
                            <span v-else>{{ scope.row.url | strFmt }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="opt" label="操作" align="center">
                        <template slot-scope="scope">
                            <div class="link">
                                <el-link type="primary" @click="EditProShow(scope.row)">编辑</el-link>
                                <el-link type="danger" @click="deleteProduct(scope.row.id)">删除</el-link>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pageList">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="page"
                        :page-sizes="[10, 20, 30, 40]"
                        :page-size="size"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                        background
                    >
                    </el-pagination>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogVisible = false" size="medium">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="编辑" :visible.sync="editDialogVisible" width="576px">
            <el-form :model="editForm" label-position="left" :rules="editFormRules" label-width="120px">
                <el-form-item label="平台名称：" prop="platform_id">
                    <el-select v-model="editForm.platform_id" placeholder="请选择平台名称" style="width: 400px">
                        <el-option v-for="item in platformList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品URL地址：" prop="url">
                    <el-input v-model="editForm.url" placeholder="请输入商品URL地址" clearable style="width: 400px"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editDialogVisible = false" size="medium">取 消</el-button>
                <el-button type="primary" @click="EditProduct" size="medium" :loading="editload">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
export default {
    data() {
        return {
            editload: false,
            addLoad: false,
            tabload: false,
            page: 1,
            size: 10,
            total: 0,
            dialogVisible: false,
            editDialogVisible: false,
            editForm: {
                platform_id: "",
                url: "",
            },
            editFormRules: {
                platform_id: [{ required: true, message: "请选择平台名称", trigger: "change" }],
                url: [{ required: true, message: "商品url地址", trigger: "blur" }],
            },
            formInline: {
                platform_id: "",
                url: "",
            },
            tableData: [],
            id: null,
            compete_product_id: 0,
        };
    },
    filters: {
        strFmt(val) {
            if (val) {
                if (val.length > 24) {
                    return val.substring(0, 24) + "...";
                }
                return val;
            }
            return "-";
        },
    },
    props: {
        platformList: {
            type: Array,
            default: () => {
                return [];
            },
        },
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    created() {
        this.getPlatformList(0);
    },
    methods: {
        ...mapActions({
            getProductPlatform: "brand/getProductPlatform",
            createProductPlatform: "brand/createProductPlatform",
            deleteProductPlatform: "brand/deleteProductPlatform",
            editProductPlatform: "brand/editProductPlatform",
        }),
        close() {
            this.$refs.formInline.resetFields();
            this.formInline = {
                id: "",
                url: "",
            };
            this.dialogVisible = false;
        },
        // 显示编辑平台弹窗
        EditProShow(row) {
            this.id = row.id;
            this.editForm = JSON.parse(JSON.stringify(row));
            this.editDialogVisible = true;
        },
        // 编辑平台
        EditProduct() {
            this.editload = true;
            let params = {
                id: this.id,
                token: this.getToken,
                name: this.editForm.name,
                compete_product_id: this.compete_product_id,
                platform_id: this.editForm.platform_id,
                url: this.editForm.url,
            };
            this.editProductPlatform(params).then(({ data }) => {
                this.editload = false;
                if (data.code == 1) {
                    this.$message.success("修改成功！");
                    this.editDialogVisible = false;
                    this.getPlatformList(1);
                    this.$emit("init");
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        // 删除平台
        deleteProduct(id) {
            this.$confirm("确实删除该平台？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    let params = {
                        id: id,
                        token: this.getToken,
                    };
                    this.deleteProductPlatform(params).then(({ data }) => {
                        if (data.code == 1) {
                            this.$message.success("删除成功！");
                            this.getPlatformList(0);
                            this.$emit("init");
                        } else {
                            this.$message.error(data.msg);
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        // 添加平台
        createProduct() {
            this.addLoad = true;
            let params = {
                token: this.getToken,
                compete_product_id: this.compete_product_id,
                platform_id: this.formInline.platform_id,
                url: this.formInline.url,
            };
            this.createProductPlatform(params).then(({ data }) => {
                this.addLoad = false;
                if (data.code == 1) {
                    this.$message.success("添加成功!");
                    this.reset();
                    this.getPlatformList(0);
                    this.$emit("init");
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        // 获取平台列表
        getPlatformList(tag) {
            let params = {
                compete_product_id: this.compete_product_id,
                token: this.getToken,
                page: tag == 0 ? 1 : this.page,
                size: this.size,
            };
            this.getProductPlatform(params).then(({ data }) => {
                if (data.code == 1) {
                    this.tableData = data.data.list;
                    this.total = data.data.count;
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        bindData() {
            this.dialogVisible = true;
            this.getPlatformList(0);
        },
        onSubmit() {
            this.getPlatformList(0);
        },
        reset() {
            this.formInline = {
                platform_id: "",
                url: "",
            };
        },
        handleSizeChange(val) {
            this.size = val;
            this.getPlatformList(1);
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getPlatformList(1);
        },
    },
};
</script>

<style lang="scss" scoped>
.select-product {
    ::v-deep .has-gutter tr th {
        background-color: rgb(217, 236, 255) !important;
    }
    .pageList {
        text-align: right;
        margin-top: 20px;
    }
}
.link {
    a {
        margin: 0 8px;
    }
}
.el-table {
    height: 350px;
    overflow-y: auto;
}
</style>